<!-- ScoreYSQ114.vue -->
<template>
  <v-card>
    <v-card-title>{{ $t('scales.ysq114.title') }}</v-card-title>
    <v-card-text>
      <p class="mb-4 text-body-2">
        {{ $t('scales.ysq114.description') }}
      </p>

      <!-- Display schemas sorted by mean score -->
      <div v-for="schema, idx in sortedSchemas" :key="schema.code" class="mb-4">
        <div class="d-flex flex-row align-center">
          <div class="d-flex flex-column mr-3" style="min-width: 200px;">
            <div class="font-weight-bold">{{ schema.name }}</div>
            <div class="text-caption text-grey">{{ schema.code }}</div>
          </div>
          <div class="flex-grow-1">
            <div class="d-flex align-center">
              <div class="progress-container mr-3">
                <v-progress-linear
                  :model-value="(schema.mean / schema.max) * 100"
                  :color="getSchemaColor(schema.mean)"
                  height="25"
                >
                  <template v-slot:default>
                    <strong class="text-black">{{ schema.mean.toFixed(2) }} / {{ schema.max.toFixed(1) }}</strong>
                  </template>
                </v-progress-linear>
                <!-- Threshold indicator at medium threshold -->
                <div
                  v-if="schema.thresholds"
                  class="threshold-line"
                  :style="{ left: `${(schema.thresholds.medium / schema.max) * 100}%` }"
                ></div>
              </div>
              <v-chip
                :color="getSchemaColor(schema.mean)"
                size="small"
                variant="flat"
              >
                {{ getSchemaLevel(schema.mean) }}
              </v-chip>
            </div>
          </div>
        </div>
      </div>

      <v-divider class="my-4"></v-divider>

      <div class="mt-4">
        <strong>{{ $t('scales.ysq114.interpretation') }}</strong>
        <!-- <p class="mt-2">{{ interpretation }}</p> -->
        <v-list :items="interpretations">
        </v-list>
      </div>

      <!-- Legend -->
      <v-card variant="outlined" class="mt-4 pa-3">
        <div class="text-subtitle-2 mb-2">{{ $t('scales.ysq114.severityLevels') }}</div>
        <div class="d-flex flex-wrap gap-2">
          <v-chip size="small" color="green">{{ $t('scales.ysq114.legend.low') }}</v-chip>
          <v-chip size="small" color="yellow-darken-2">{{ $t('scales.ysq114.legend.moderate') }}</v-chip>
          <v-chip size="small" color="orange">{{ $t('scales.ysq114.legend.high') }}</v-chip>
          <v-chip size="small" color="red">{{ $t('scales.ysq114.legend.veryHigh') }}</v-chip>
        </div>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ScoreYSQ114',
  data() {
    return {
      scale_id: 'ysq114',
    }
  },
  props: {
    scale: {
      type: Object,
      required: true
    },
  },

  created(){
    console.log(`ScoreYSQ114 created`)
    console.log('Scores:', this.scores)
  },

  computed: {
    scores() {
      return this.scale.scores;
    },

    interpretations() {
      return this.scale.interpretations;
    },

    sortedSchemas() {
      // Convert scores object to array and sort by mean score (descending)
      if (!this.scores) return [];

      return Object.keys(this.scores).map(code => ({
        code: code,
        name: this.scores[code].name,
        mean: this.scores[code].raw.mean,
        value: this.scores[code].raw.value,
        min: this.scores[code].raw.min,
        max: this.scores[code].raw.max,
        thresholds: this.scores[code].thresholds
      })).sort((a, b) => b.mean - a.mean);
    }
  },

  methods: {
    getSchemaColor(mean) {
      if (mean >= 4.5) return 'red';
      if (mean >= 3.5) return 'orange';
      if (mean >= 2.5) return 'yellow-darken-2';
      return 'green';
    },

    getSchemaLevel(mean) {
      if (mean >= 4.5) return this.$t('scales.ysq114.levels.veryHigh');
      if (mean >= 3.5) return this.$t('scales.ysq114.levels.high');
      if (mean >= 2.5) return this.$t('scales.ysq114.levels.moderate');
      return this.$t('scales.ysq114.levels.low');
    }
  }
}
</script>

<style scoped>
.gap-2 {
  gap: 8px;
}

.progress-container {
  position: relative;
  flex-grow: 1;
}

.threshold-line {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 2px;
  background-color: rgba(0, 0, 0, 0.6);
  pointer-events: none;
  z-index: 1;
}

.threshold-line::before {
  content: '';
  position: absolute;
  top: -4px;
  left: -3px;
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 6px solid rgba(0, 0, 0, 0.6);
}

.threshold-line::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: -3px;
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 6px solid rgba(0, 0, 0, 0.6);
}
</style>
